import React from "react";
import { Paper } from "@activecollab/components";
import PropTypes from "prop-types";
import { Page } from "~/components/Page";
import MainLogo from "~/components/svg/MainLogo";
import TermsAndConditions from "~/pages/People/Invitation/TermsAndConditions";

export const PublicLayout = ({ children, title, shouldShowTerms, topSection, paperClassName, bodyClassName }) => {
  return (
    <Page
      title={title}
      className="tw-w-[384px] md:tw-w-[718px] lg:tw-w-[984px] md:tw-min-w-[644px] tw-m-auto tw-pt-0 lg:tw-px-8 tw-pb-8"
    >
      <div className="tw-flex tw-items-center tw-my-5 tw-h-10">
        <MainLogo className="tw-m-auto" />
      </div>
      <Page.Body className={bodyClassName}>
        {topSection ? topSection : null}
        <Paper
          type="paper-2"
          className={paperClassName ?? "tw-pt-6 tw-pb-20"}
        >
          {children}
        </Paper>
      </Page.Body>
      {shouldShowTerms ? <TermsAndConditions /> : null}
    </Page>
  );
};

PublicLayout.propTypes = {
  children: PropTypes.any,
  title: PropTypes.string,
  shouldShowTerms: PropTypes.bool,
  topSection: PropTypes.element,
  paperClassName: PropTypes.string,
  bodyClassName: PropTypes.string,
};

export default PublicLayout;
